import React from 'react';
import DailyBarChartWrapper from './DailyBarChartWrapper';
import MonthlyBarChartWrapper from './MonthlyBarChartWrapper';
import { Tabs } from 'antd';

const { TabPane } = Tabs;

const EnrolmentChart = () => {
  return (
    <div>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Daily" key="1">
          <DailyBarChartWrapper />
        </TabPane>
        <TabPane tab="Last 5 months" key="2">
          <MonthlyBarChartWrapper />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default EnrolmentChart;
